import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel.js";
import Point from "@arcgis/core/geometry/Point.js";
import Mesh from "@arcgis/core/geometry/Mesh.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";

import FillSymbol3DLayer from "@arcgis/core/symbols/FillSymbol3DLayer.js";
import MeshSymbol3D from "@arcgis/core/symbols/MeshSymbol3D.js";
import Graphic from "@arcgis/core/Graphic.js";
import PopUp from "./PopUp.js";
import { sharedDownloadQueue } from "../layerlist/DownloadsQue.js";
let counter = 0;
let viewe;
let sketchLayer;
let sketchViewModel;
let projekListInter = [];

export default class InsertBuilding {
  constructor() {
    const view = document.querySelector("#viewDiv");

    if (projekListInter.length > 0) {
      return this.projectList;
    } else {
      projekListInter = [];
    }

    if (counter === 0) {
      viewe = view.view;
      sketchLayer = new GraphicsLayer({
        listMode: "hide",
      });
      view.map.add(sketchLayer);

      sketchViewModel = new SketchViewModel({
        layer: sketchLayer,
        view: view.view,
        tooltipOptions: { enabled: true },
      });

      counter++;
    }
  }

  async getZcoordinate(cordinates) {
    const point = new Point({
      x: cordinates.x,
      y: cordinates.y,
      spatialReference: "4326",
    });
    const groundPoint = await viewe.map.ground.queryElevation(point);

    return groundPoint;
  }

  async fromGLBfile(glbFile) {
    //const glbBuffer = await glbFile.async("arraybuffer");
    const glbBlob = new Blob([glbFile], { type: "model/gltf-binary" });

    const mesh = await Mesh.createFromGLTF(
      new Point(), // Origin of the model.
      URL.createObjectURL(glbBlob), // Url pointing to the 3D model file.
      { vertexSpace: "local" }, // In case of scenes in geographic or WebMercator spatial references, the vertexSpace needs to be set to "local".
    );

    await mesh.load();

    sketchViewModel.place(mesh);
    sharedDownloadQueue.setActive(mesh);
    return mesh;
  }

  async fromSample() {
    const mesh = await Mesh.createFromGLTF(
      new Point(), // Origin of the model.
      "./models/sample_building.glb", // Url pointing to the 3D model file.
      { vertexSpace: "local" }, // In case of scenes in geographic or WebMercator spatial references, the vertexSpace needs to be set to "local".
    );

    await mesh.load();

    sketchViewModel.place(mesh);
    sharedDownloadQueue.setActive(mesh);
    return mesh;
  }

  async fromWebApp(zipFile) {
    const csvFile = zipFile[1];
    const glbFile = zipFile[0];
    const csvText = await csvFile.async("text");
    const csvRows = csvText
      .trim()
      .split("\n")
      .map((row) => row.split(","));
    const glbBuffer = await glbFile.async("arraybuffer");
    const glbBlob = new Blob([glbBuffer], { type: "model/gltf-binary" });
    // Create mesh from the 3D building model.
    const mesh = await Mesh.createFromGLTF(
      new Point({
        x: Number(csvRows[1][0]),
        y: Number(csvRows[1][1]),
        z: Number(csvRows[1][2]),
      }), // Origin of the model.
      URL.createObjectURL(glbBlob), // Url pointing to the 3D model file.
      { vertexSpace: "local" }, // In case of scenes in geographic or WebMercator spatial references, the vertexSpace needs to be set to "local".
    );

    // Remove default orange symbol
    const emptySymbol = new MeshSymbol3D({
      symbolLayers: [new FillSymbol3DLayer()],
    });

    // Create new graphic
    let graphic = new Graphic({
      geometry: mesh,
      symbol: emptySymbol,
      listMode: "hide",
    });

    return {
      name: csvRows[1][3],
      mesh: graphic,
      id: new Date().getTime(),
    };
  }

  addGraphicToWiew(attributes) {
    viewe.graphics.add(attributes.mesh);
    new PopUp(viewe, attributes.mesh, attributes.name);
  }

  async fromArcGISpro(zipFile, ziszero) {
    const findByExt = (ext) =>
      zipFile.find((f) => !f.dir && f.name.toLowerCase().endsWith(ext));

    const projectName = zipFile[0].name.replace(/^OID_\d+_/, "");

    const jsonFIle = findByExt(".json");
    const glbEntry = findByExt(".glb");

    const glbBuffer = await glbEntry.async("arraybuffer");
    const glbBlob = new Blob([glbBuffer], { type: "model/gltf-binary" });

    const jsonText = await jsonFIle.async("string"); // UTF-8 text
    const jsonData = JSON.parse(jsonText);

    let zValue = jsonData.attributes.ESRI3DO_OZ;

    if (ziszero) {
      const coordinates = await this.getZcoordinate({
        x: jsonData.attributes.ESRI3DO_OX,
        y: jsonData.attributes.ESRI3DO_OY,
      });

      zValue = coordinates.geometry.z;
    }

    const mesh = await Mesh.createFromGLTF(
      new Point({
        x: jsonData.attributes.ESRI3DO_OX,
        y: jsonData.attributes.ESRI3DO_OY,
        z: zValue,
      }), // Origin of the model.
      URL.createObjectURL(glbBlob), // Url pointing to the 3D model file.
      { vertexSpace: "local" }, // In case of scenes in geographic or WebMercator spatial references, the vertexSpace needs to be set to "local".
    );

    // Remove default orange symbol
    const emptySymbol = new MeshSymbol3D({
      symbolLayers: [new FillSymbol3DLayer()],
    });

    // Create new graphic
    let graphic = new Graphic({
      geometry: mesh,
      symbol: emptySymbol,
      listMode: "hide",
    });

    return {
      name: projectName.slice(0, -1),
      mesh: graphic,
      id: new Date().getTime(),
    };
  }
}
